
import React from 'react'
  
 
export const HeroSection = () => {


    return (
      <div className="hero">
            <div className="herosection">
                <div className="introduce">
                    <h1 className="title">NOVA - Multipurpose Directory & Listing Theme</h1>
                    <p className="description">
                    Fast, Comprehensive React & Nextjs Template. Easy to use with advanced and rich components. 
                    Hybrid features adaptable for different environments. You can use at wide range for your applications and for special softwares                    
                    </p>
                    <div className="store">
                        <a href="https://play.google.com/store/" target="_blank" rel="noreferrer"  ><img src="/assets/images/assets/appstore.png" className="app"  alt=""/></a>
                        <a href="https://www.apple.com/app-store/" target="_blank" rel="noreferrer"  ><img src="/assets/images/assets/applestore.png" className="app"  alt=""/></a>
                    </div>
                </div>
                <div>
                    <img src="/assets/images/bg/phone.png" className="cover" draggable="false" alt="" />
                </div>
            </div>
            <div className="wave">
                <svg className="shake" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                    <path fill="#0099ff" fill-opacity="1" d="M0,128L26.7,149.3C53.3,171,107,213,160,213.3C213.3,213,267,171,320,170.7C373.3,171,427,213,480,224C533.3,235,587,213,640,213.3C693.3,213,747,235,800,213.3C853.3,192,907,128,960,112C1013.3,96,1067,128,1120,128C1173.3,128,1227,96,1280,106.7C1333.3,117,1387,171,1413,197.3L1440,224L1440,320L1413.3,320C1386.7,320,1333,320,1280,320C1226.7,320,1173,320,1120,320C1066.7,320,1013,320,960,320C906.7,320,853,320,800,320C746.7,320,693,320,640,320C586.7,320,533,320,480,320C426.7,320,373,320,320,320C266.7,320,213,320,160,320C106.7,320,53,320,27,320L0,320Z"></path>
                </svg>
            </div>

                {/** 
                 <div className="wave-bg">
                    <img src="/assets/images/bg/wave.svg" className="wave" draggable="false" />
                    <div className="bg"></div> 
                 </div>
                **/}
      </div>
    )
}  
 

